import { render } from "./GuidelineNav.vue?vue&type=template&id=3cd79fb5&scoped=true"
import script from "./GuidelineNav.vue?vue&type=script&lang=js"
export * from "./GuidelineNav.vue?vue&type=script&lang=js"

import "./GuidelineNav.vue?vue&type=style&index=0&id=3cd79fb5&scoped=true&lang=css"

import exportComponent from "/var/www/html/bcsprostuti-web-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cd79fb5"]])

export default __exports__